import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/hooks';
import { useCreateRadioStation } from '@/hooks';
import { CreateRadioStationRequest } from '@/types/model';
import RadioStationForm from '@/components/forms/RadioStationForm';
import Button from '@/components/ui/Button.tsx';
import toast from 'react-hot-toast';

const CreateRadioStation = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const createRadioStationMutation = useCreateRadioStation();

  const handleSuccess = async (data: CreateRadioStationRequest) => {
    try {
      await createRadioStationMutation.mutateAsync(data);
      toast.success(t.radioStations.messages.created);
      navigate('/content/radio-stations');
    } catch (error) {
      console.error('Create error:', error);
      toast.error(error instanceof Error ? error.message : t.errors.unexpectedError);
      throw error; // Re-throw to let form handle the error
    }
  };

  const handleCancel = () => {
    navigate('/content/radio-stations');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={handleCancel}
          variant="link"
        >
          ← Volver a la lista
        </Button>

        <RadioStationForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isSubmitting={createRadioStationMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateRadioStation;
